import { styled } from "@acko-tech/building-blocks.ui.common";

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  margin-top: 30px;
`;
export const Tile = styled.div`
  padding: 10px 16px;
  font-size: 16px;
  background-color: ${props => (props.selected ? "#0fa457" : "transparent")};
  font-weight: ${props => (props.selected ? "600" : "400")};
  color: ${props => (props.selected ? "white" : "#040222")};
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  text-align: center;
  width: 65px;
`;

export const RegistrationYearHeader = styled.div<{ isDesktop?: boolean }>`
color: var(--Text-Primary, #040222);
font-size: 18px;
font-style: normal;
font-weight: 600;
line-height: 24px;
@media (min-width: 768px) {
    margin-left: 83px;
  }
`;
